import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import TextareaAutosize from 'react-autosize-textarea';
import { Modal } from 'react-bootstrap';
import { putRequest } from '../../../requestUtils';
import LocationAutocomplete from '../../common/LocationAutocomplete';
import ProjectLoadingIndicator from '../ProjectLoadingIndicator';
import './ProjectBudgetLogistics.scss';
import FilterTag from '../../common/FilterTag';
import MultipleButtonSelect from '../../common/MultipleButtonSelect';
import SearchIcon from '../../../../assets/images/search-icon.svg';
var travelChoices = {
  notApplicable: 'n/a',
  notSure: 'not sure',
  travel: 'travel'
};
var officeChoices = {
  notSure: 'not sure',
  remote: 'remote',
  office: 'office',
  hybrid: 'hybrid'
};
var officeOptions = [{
  title: 'Remote',
  value: 'remote'
}, {
  title: 'In-Office',
  value: 'office'
}, {
  title: 'Hybrid',
  value: 'hybrid'
}, {
  title: 'Do not know yet',
  value: 'not sure'
}];
var authorizationOptions = [{
  title: 'Yes',
  value: true
}, {
  title: 'No',
  value: false
}];
var backgroundChecksOptions = ['Background checks', 'Drug Screen', 'Covid Vaccine Proof'];
var getDefaultOfficeData = function getDefaultOfficeData(officeData) {
  var result = {
    choice: officeData.work_location,
    days: '' || 5,
    required: false,
    location: ''
  };
  if (result.choice === officeChoices.office || result.choice === officeChoices.hybrid) {
    result.days = officeData.days_in_office || 5;
    result.required = officeData.office_location_required;
    result.location = officeData.office_location;
  }
  return result;
};
var getDefaultTravelData = function getDefaultTravelData(travelData) {
  var result = {
    choice: travelData.travel_time || travelChoices.notApplicable,
    days: '',
    locations: [{
      id: null,
      description: ''
    }],
    required: false
  };
  if (result.choice === travelChoices.travel) {
    result.days = travelData.days_of_travel;
    result.required = travelData.travel_location_required;
    result.locations = travelData.travel_locations;
  }
  return result;
};
var ProjectBudgetLogistics = /*#__PURE__*/function (_React$Component) {
  function ProjectBudgetLogistics(props) {
    var _this;
    _classCallCheck(this, ProjectBudgetLogistics);
    _this = _callSuper(this, ProjectBudgetLogistics, [props]);
    _this.state = {
      loading: true,
      showModal: false,
      office: {
        choice: '',
        days: '' || 5,
        location: '',
        required: false
      },
      travel: {
        choice: '',
        days: '',
        locations: [],
        required: false
      },
      deletedTravelLocationIds: [],
      selectedProjectLength: null,
      // option object with value/label
      selectedHoursPerWeek: null,
      // option object with value/label
      projectLengthPicklist: [],
      hoursPerWeekPicklist: [],
      budgetMinimum: '',
      budgetMaximum: '',
      basePayHidden: false,
      workAuthorizationRequired: null,
      compensationBenefitNote: '',
      backgroundCheckType: []
    };
    _this.handleBack = _this.handleBack.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.setAttribute = _this.setAttribute.bind(_this);
    _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_this);
    _this.renderBackgroundChecks = _this.renderBackgroundChecks.bind(_this);
    _this.addBlankTravelLocation = _this.addBlankTravelLocation.bind(_this);
    _this.handleWorkplaceTypeChange = _this.handleWorkplaceTypeChange.bind(_this);
    _this.handleBackgroundCheckSelect = _this.handleBackgroundCheckSelect.bind(_this);
    _this.renderCompensationAndBenefits = _this.renderCompensationAndBenefits.bind(_this);
    _this.travelLocationsKey = 0;
    return _this;
  }
  _inherits(ProjectBudgetLogistics, _React$Component);
  return _createClass(ProjectBudgetLogistics, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var getProjectDetails = this.props.getProjectDetails;
      getProjectDetails('logistics').then(function (_ref) {
        var data = _ref.data;
        _this2.setInitialState(data);
      });
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(object, field, value) {
      var oldObj = this.state[object];
      var newObj = update(oldObj, _defineProperty({}, field, {
        $set: value
      }));
      this.setState(_defineProperty({}, object, newObj));
    }
  }, {
    key: "getTravelLocationParams",
    value: function getTravelLocationParams() {
      var deleteLocations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$state = this.state,
        travel = _this$state.travel,
        deletedTravelLocationIds = _this$state.deletedTravelLocationIds;
      var result = {};
      var filteredLocations;
      if (deleteLocations) {
        filteredLocations = travel.locations.filter(function (location) {
          return location.id;
        }).map(function (location) {
          return {
            id: location.id,
            _destroy: 1
          };
        });
      } else {
        filteredLocations = travel.locations.filter(function (location) {
          return location.description;
        });
      }
      var deletedTravelLocations = deletedTravelLocationIds.map(function (id) {
        return {
          id: id,
          _destroy: 1
        };
      });
      var locationsArr = filteredLocations.concat(deletedTravelLocations);
      locationsArr.forEach(function (location, index) {
        result[index] = location;
      });
      return result;
    }
  }, {
    key: "setTravelLocation",
    value: function setTravelLocation(index, description) {
      var travel = this.state.travel;
      var newTravel = update(travel, {
        choice: {
          $set: description === '' ? 'n/a' : 'travel'
        },
        locations: _defineProperty({}, index, {
          description: {
            $set: description
          }
        })
      });
      this.setState({
        travel: newTravel
      });
    }

    // data from getProjectDetails() request
  }, {
    key: "setInitialState",
    value: function setInitialState(data) {
      var projectLengthPicklist = data.duration_picklist;
      var hoursPerWeekPicklist = data.hours_picklist;
      var defaultOfficeData = getDefaultOfficeData(data);
      var defaultTravelData = getDefaultTravelData(data);
      this.setState({
        loading: false,
        budgetMinimum: String(data.budget_minimum || '').toLocaleString(),
        budgetMaximum: String(data.budget_maximum || '').toLocaleString(),
        rateNegotiable: data.rate_negotiable,
        remoteLocation: data.remote_preferred_location,
        projectLengthPicklist: projectLengthPicklist,
        hoursPerWeekPicklist: hoursPerWeekPicklist,
        office: defaultOfficeData,
        travel: defaultTravelData,
        deletedTravelLocationIds: [],
        selectedProjectLength: {
          value: data.duration_range,
          label: data.duration_range
        },
        selectedHoursPerWeek: {
          value: data.avg_time_required_range,
          label: data.avg_time_required_range
        },
        basePayHidden: data.base_pay_hidden,
        employmentType: data.employment_type,
        workAuthorizationRequired: data.us_work_authorization_required,
        remotePreferredLocationNotApplicable: data.remote_preferred_location_not_applicable,
        travelLocationNotApplicable: data.travel_location_not_applicable,
        backgroundCheckType: data.background_check_type,
        compensationBenefitNote: data.compensation_benefit_note
      });
    }
  }, {
    key: "addTravelLocationAttrs",
    value: function addTravelLocationAttrs(attrs) {
      var travel = this.state.travel;

      // populate attributes only if travel is chosen
      if (travel.choice === travelChoices.travel) {
        var travelLocations = this.getTravelLocationParams();
        Object.assign(attrs, {
          days_of_travel: travel.days,
          travel_location_required: travel.required,
          project_travel_locations_attributes: travelLocations
        });
      } else {
        // if travel is not chosen, destroy any chosen travel locations
        var _travelLocations = this.getTravelLocationParams(true);
        Object.assign(attrs, {
          project_travel_locations_attributes: _travelLocations
        });
      }
    }
  }, {
    key: "addOfficeLocationAttrs",
    value: function addOfficeLocationAttrs(attrs) {
      var _this$state2 = this.state,
        office = _this$state2.office,
        remoteLocation = _this$state2.remoteLocation;

      // populate attributes only if office work is chosen
      if (office.choice === officeChoices.office || office.choice === officeChoices.hybrid) {
        Object.assign(attrs, {
          office_location: office.location,
          office_days: office.days,
          days_in_office: office.days,
          office_location_required: office.required
        });
      } else if (office.choice === officeChoices.remote) {
        Object.assign(attrs, {
          office_location: office.location,
          remote_preferred_location: remoteLocation
        });
      }
    }
  }, {
    key: "removeTravelLocation",
    value: function removeTravelLocation(index) {
      var travel = this.state.travel;
      var deletedLocation = this.state.travel.locations[index];
      var newTravel = update(travel, {
        locations: {
          $splice: [[index, 1]]
        }
      });
      if (deletedLocation.id) {
        var newDeletedLocationIds = update(this.state.deletedTravelLocationIds, {
          $push: [deletedLocation.id]
        });
        this.setState({
          deletedTravelLocationIds: newDeletedLocationIds
        });
      }
      this.setState({
        travel: newTravel
      });
    }
  }, {
    key: "ableToSubmit",
    value: function ableToSubmit() {
      var _this$state3 = this.state,
        office = _this$state3.office,
        travel = _this$state3.travel,
        budgetMinimum = _this$state3.budgetMinimum,
        budgetMaximum = _this$state3.budgetMaximum,
        backgroundCheckType = _this$state3.backgroundCheckType;
      var travelValid = true;
      var officeValid = office.choice;
      var budgetLow = Number(String(budgetMinimum).replace(/,/, ''));
      var budgetHigh = Number(String(budgetMaximum).replace(/,/, ''));
      var budgetValid = budgetLow >= 1 && budgetHigh >= 1 && budgetHigh > budgetLow;
      if (travel.choice && travel.choice === travelChoices.travel) {
        travelValid = travel.locations.filter(function (location) {
          return location.description;
        }).length > 0;
      }
      if (office.choice === officeChoices.office || office.choice === officeChoices.hybrid) {
        var parsedDays = parseInt(office.days, 10);
        officeValid = office.days && office.location && parsedDays >= 0 && parsedDays <= 7;
      }
      return budgetValid && officeValid && travelValid && backgroundCheckType;
    }
  }, {
    key: "addBlankTravelLocation",
    value: function addBlankTravelLocation() {
      var travel = this.state.travel;
      this.travelLocationsKey -= 1;
      var newTravel = update(travel, {
        locations: {
          $push: [{
            id: null,
            description: '',
            _destroy: false,
            key: this.travelLocationsKey
          }]
        }
      });
      this.setState({
        travel: newTravel
      });
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      if (this.props.formType === 'page') {
        this.props.back();
      } else {
        this.setState({
          showModal: false
        });
      }
    }
  }, {
    key: "handleOnKeyDown",
    value: function handleOnKeyDown(event) {
      if (event.keyCode === 32) {
        event.stopPropagation();
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        csrfToken = _this$props.csrfToken,
        afterSubmit = _this$props.afterSubmit;
      var _this$state4 = this.state,
        office = _this$state4.office,
        travel = _this$state4.travel,
        budgetMinimum = _this$state4.budgetMinimum,
        budgetMaximum = _this$state4.budgetMaximum,
        rateNegotiable = _this$state4.rateNegotiable,
        basePayHidden = _this$state4.basePayHidden,
        workAuthorizationRequired = _this$state4.workAuthorizationRequired,
        remotePreferredLocationNotApplicable = _this$state4.remotePreferredLocationNotApplicable,
        travelLocationNotApplicable = _this$state4.travelLocationNotApplicable,
        backgroundCheckType = _this$state4.backgroundCheckType,
        compensationBenefitNote = _this$state4.compensationBenefitNote;
      var projectAttributes = {
        budget_minimum: String(budgetMinimum).replace(/,/, ''),
        budget_maximum: String(budgetMaximum).replace(/,/, ''),
        rate_negotiable: rateNegotiable,
        travel_time: travel.choice,
        days_of_travel: null,
        travel_location_required: false,
        work_location: office.choice,
        office_location: null,
        office_days: null,
        days_in_office: null,
        office_location_required: false,
        remote_preferred_location: null,
        base_pay_hidden: basePayHidden,
        us_work_authorization_required: workAuthorizationRequired,
        remote_preferred_location_not_applicable: remotePreferredLocationNotApplicable,
        travel_location_not_applicable: travelLocationNotApplicable,
        background_check_type: backgroundCheckType,
        compensation_benefit_note: compensationBenefitNote
      };
      this.addOfficeLocationAttrs(projectAttributes);
      this.addTravelLocationAttrs(projectAttributes);
      putRequest("/projects/".concat(projectResourceId), {
        project: projectAttributes
      }, csrfToken).then(function () {
        return afterSubmit();
      });
    }
  }, {
    key: "handleWorkplaceTypeChange",
    value: function handleWorkplaceTypeChange(choice) {
      this.setAttribute('office', 'choice', choice);
    }
  }, {
    key: "handleBackgroundCheckSelect",
    value: function handleBackgroundCheckSelect(value) {
      var backgroundCheckType = this.state.backgroundCheckType;
      if (backgroundCheckType.includes(value)) {
        backgroundCheckType.pop(value);
      } else {
        backgroundCheckType.push(value);
      }
      this.setState({
        backgroundCheckType: backgroundCheckType
      });
    }
  }, {
    key: "renderOfficeLocationInput",
    value: function renderOfficeLocationInput() {
      var _this3 = this;
      var office = this.state.office;
      return /*#__PURE__*/React.createElement("div", {
        className: "location-input"
      }, /*#__PURE__*/React.createElement(LocationAutocomplete, {
        inputId: "office-location-input",
        value: office.location,
        onValueChange: function onValueChange(newLocation) {
          return _this3.setAttribute('office', 'location', newLocation);
        },
        defaultSample: "Ex: 123 Boston Way, Boston, MA"
      }), /*#__PURE__*/React.createElement("img", {
        src: SearchIcon,
        className: "search-icon",
        alt: "search-icon"
      }));
    }
  }, {
    key: "renderRemoteLocationInput",
    value: function renderRemoteLocationInput() {
      var _this4 = this;
      var remotePreferredLocationNotApplicable = this.state.remotePreferredLocationNotApplicable;
      var remoteLocation = this.state.remoteLocation;
      return /*#__PURE__*/React.createElement("div", {
        className: "remote-preferred-location mb-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("input", {
        className: "remote-location-input",
        type: "text",
        id: "remote-location-input",
        name: "remote-location-input",
        value: remoteLocation || '',
        onChange: function onChange(newLocation) {
          return _this4.setState({
            remoteLocation: newLocation.target.value
          });
        },
        placeholder: remotePreferredLocationNotApplicable ? 'N/A' : 'Ex: Bay area, CA; Conn, NJ, or NY',
        disabled: remotePreferredLocationNotApplicable
      })), /*#__PURE__*/React.createElement("div", {
        className: "g-row remote-location-not-applicable mt-2"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "remote-preferred-location-not-applicable",
        className: "custom-checkbox-container"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "remote-preferred-location-not-applicable",
        name: "remote-preferred-location-not-applicable",
        className: "checkbox-box",
        checked: remotePreferredLocationNotApplicable,
        onChange: function onChange(e) {
          return _this4.setState({
            remotePreferredLocationNotApplicable: e.target.checked,
            remoteLocation: ''
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text ".concat(remotePreferredLocationNotApplicable ? 'active' : '')
      }, "Not Applicable"))));
    }
  }, {
    key: "renderWorkAuthorization",
    value: function renderWorkAuthorization() {
      var _this5 = this;
      var _this$state5 = this.state,
        employmentType = _this$state5.employmentType,
        workAuthorizationRequired = _this$state5.workAuthorizationRequired;
      if (employmentType === 'full_time') {
        return /*#__PURE__*/React.createElement("div", {
          className: "work-authorization-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "logistics-header"
        }, "Do you require candidates to have a work authorization for the United States?", /*#__PURE__*/React.createElement("span", {
          className: "required-text"
        }, "* Required")), /*#__PURE__*/React.createElement(FilterTag, {
          options: authorizationOptions,
          handleChange: function handleChange(newState) {
            return _this5.setState({
              workAuthorizationRequired: newState
            });
          },
          selected: workAuthorizationRequired
        }));
      }
      return null;
    }
  }, {
    key: "renderWorkplaceChoice",
    value: function renderWorkplaceChoice() {
      return /*#__PURE__*/React.createElement("div", {
        className: "workplace-type-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, "Workplace Type", /*#__PURE__*/React.createElement("span", {
        className: "required-text"
      }, "* Required")), /*#__PURE__*/React.createElement(FilterTag, {
        options: officeOptions,
        handleChange: this.handleWorkplaceTypeChange,
        selected: this.state.office.choice
      }));
    }
  }, {
    key: "renderOfficeQuestion",
    value: function renderOfficeQuestion() {
      var _this6 = this;
      var officeType = this.state.office.choice;
      return /*#__PURE__*/React.createElement("div", {
        className: "workplace-questions-container"
      }, (officeType === 'office' || officeType === 'hybrid') && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, "Days in the Office", /*#__PURE__*/React.createElement("span", {
        className: "required-text"
      }, "* Required")), /*#__PURE__*/React.createElement("div", {
        className: "office-days-container"
      }, /*#__PURE__*/React.createElement("input", {
        className: "office-days-input",
        placeholder: "0",
        type: "number",
        id: "office-days",
        name: "office-days",
        onChange: function onChange(e) {
          return _this6.setAttribute('office', 'days', e.target.value);
        },
        value: this.state.office.days
      }), /*#__PURE__*/React.createElement("span", {
        className: "office-days-text"
      }, "days per week in the office.")), /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, "Office Location", /*#__PURE__*/React.createElement("span", {
        className: "required-text"
      }, "* Required")), this.renderOfficeLocationInput()), officeType === 'remote' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, "Desired Candidate Location"), this.renderRemoteLocationInput()));
    }
  }, {
    key: "renderTravelQuestion",
    value: function renderTravelQuestion() {
      var _this7 = this;
      var travelLocationNotApplicable = this.state.travelLocationNotApplicable;
      var travelLocation = this.state.travel.locations[0].description;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, "Travel Requirements"), /*#__PURE__*/React.createElement("div", {
        className: "travel-location mt-2"
      }, /*#__PURE__*/React.createElement("input", {
        className: "travel-location-input",
        type: "text",
        id: "travel-location-input",
        name: "travel-location-input",
        disabled: travelLocationNotApplicable,
        value: travelLocation || '',
        onChange: function onChange(newLocation) {
          return _this7.setTravelLocation(0, newLocation.target.value);
        },
        placeholder: travelLocationNotApplicable ? 'N/A' : 'Ex: 40% travel to clinical sites in the East Coast'
      })), /*#__PURE__*/React.createElement("div", {
        className: "g-row travel-not-applicable mt-2"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "travel-not-applicable",
        className: "custom-checkbox-container"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "travel-not-applicable",
        name: "travel-not-applicable",
        className: "checkbox-box",
        checked: travelLocationNotApplicable,
        onChange: function onChange(e) {
          _this7.setTravelLocation(0, '');
          _this7.setState({
            travelLocationNotApplicable: e.target.checked
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text ".concat(travelLocationNotApplicable ? 'active' : '')
      }, "Not Applicable"))));
    }
  }, {
    key: "renderHourlyRate",
    value: function renderHourlyRate() {
      var _this8 = this;
      var _this$state6 = this.state,
        rateNegotiable = _this$state6.rateNegotiable,
        budgetMinimum = _this$state6.budgetMinimum,
        budgetMaximum = _this$state6.budgetMaximum,
        basePayHidden = _this$state6.basePayHidden,
        employmentType = _this$state6.employmentType;
      var salaryFormatter = employmentType === 'full_time' ? function (e) {
        return Number(e.target.value.replace(/,/, '')).toLocaleString();
      } : function (e) {
        return Number(e.target.value);
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 normal-weight"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, employmentType === 'full_time' ? 'Annual Base Salary Range' : 'Preferred Hourly Rate', /*#__PURE__*/React.createElement("span", {
        className: "required-text"
      }, "* Required")), /*#__PURE__*/React.createElement("div", {
        className: "budget-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "budget-input-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "dollar-icon"
      }, "$"), /*#__PURE__*/React.createElement("input", {
        name: "budget-minimum",
        id: "budget-minimum",
        className: "form-control rate-form budget-input",
        placeholder: "Minimum",
        required: "required",
        value: budgetMinimum || '',
        onChange: function onChange(e) {
          return _this8.setState({
            budgetMinimum: salaryFormatter(e)
          });
        }
      })), /*#__PURE__*/React.createElement("span", {
        className: "mx-3 range-span"
      }, "-"), /*#__PURE__*/React.createElement("div", {
        className: "budget-input-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "dollar-icon"
      }, "$"), /*#__PURE__*/React.createElement("input", {
        name: "budget-maximum",
        id: "budget-maximum",
        className: "form-control rate-form budget-input",
        placeholder: "Maximum",
        required: "required",
        value: budgetMaximum || '',
        onChange: function onChange(e) {
          return _this8.setState({
            budgetMaximum: salaryFormatter(e)
          });
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "rate-question"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: employmentType === 'full_time' ? 'base-pay-hidden-checkbox' : 'rate-negotiable-checkbox',
        className: "custom-checkbox-container"
      }, employmentType === 'full_time' ? /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "base-pay-hidden-checkbox",
        name: "base-pay-hidden-checkbox",
        className: "checkbox-box",
        checked: basePayHidden,
        onChange: function onChange(e) {
          return _this8.setState({
            basePayHidden: e.target.checked
          });
        }
      }) : /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "rate-negotiable-checkbox",
        name: "rate-negotiable-checkbox",
        className: "checkbox-box",
        checked: rateNegotiable,
        onChange: function onChange(e) {
          return _this8.setState({
            rateNegotiable: e.target.checked
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), employmentType === 'full_time' ? /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text ".concat(basePayHidden ? 'active' : '')
      }, "Hide this from applicants") : /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text ".concat(rateNegotiable ? 'active' : '')
      }, "Rate is negotiable"))));
    }
  }, {
    key: "renderCompensationAndBenefits",
    value: function renderCompensationAndBenefits() {
      var _this9 = this;
      var _this$state7 = this.state,
        employmentType = _this$state7.employmentType,
        compensationBenefitNote = _this$state7.compensationBenefitNote;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 normal-weight"
      }, employmentType === 'full_time' && /*#__PURE__*/React.createElement("div", {
        className: "compensation-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, "Notes on Compensation & Benefits"), /*#__PURE__*/React.createElement(TextareaAutosize, {
        className: "compensation-note",
        placeholder: "Enter text here ",
        onChange: function onChange(event) {
          return _this9.setState({
            compensationBenefitNote: event.target.value
          });
        },
        onKeyDown: function onKeyDown(event) {
          return _this9.handleOnKeyDown(event);
        },
        value: compensationBenefitNote
      })));
    }
  }, {
    key: "renderBackgroundChecks",
    value: function renderBackgroundChecks() {
      var _this10 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "background-check-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, "Do you require candidates to undergo a drug screen, provide proof of COVID vaccination, or pass a background check?", /*#__PURE__*/React.createElement("span", {
        className: "required-text"
      }, "* Required")), /*#__PURE__*/React.createElement(MultipleButtonSelect, {
        options: backgroundChecksOptions,
        handleChange: function handleChange(value) {
          return _this10.handleBackgroundCheckSelect(value);
        },
        selected: this.state.backgroundCheckType
      }));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props2 = this.props,
        backButtonText = _this$props2.backButtonText,
        submitButtonText = _this$props2.submitButtonText;
      var nextButtonDisabled = !this.ableToSubmit();
      return /*#__PURE__*/React.createElement("div", {
        className: "footer-buttons-container mt-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleBack
      }, backButtonText), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSubmit,
        disabled: nextButtonDisabled
      }, submitButtonText));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var showBackgroundCheck = this.props.showBackgroundCheck;
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(ProjectLoadingIndicator, null);
      }
      var pageView = this.props.formType === 'page';
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-logistics-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, pageView && /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column ".concat(pageView ? 'g-flex-6' : '', " logistics-entry-container-feature")
      }, /*#__PURE__*/React.createElement("p", {
        className: "budget-header-text"
      }, "Compensations"), this.renderHourlyRate(), showBackgroundCheck && this.renderCompensationAndBenefits(), /*#__PURE__*/React.createElement("p", {
        className: "logistics-header-text mt-3"
      }, "Logistics"), this.renderWorkAuthorization(), showBackgroundCheck && this.renderBackgroundChecks(), this.renderWorkplaceChoice(), this.renderOfficeQuestion(), this.renderTravelQuestion(), this.renderButtons())));
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this11 = this;
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: function onHide() {
          return _this11.setState({
            showModal: false
          });
        },
        dialogClassName: "project-creation-modal project-logistics-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-creation-modal-heading"
      }, /*#__PURE__*/React.createElement("h1", null, "Edit Logistics"))), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "project-creation-modal-body project-logistics-modal-body"
      }, this.renderContent()));
    }
  }, {
    key: "renderModalLink",
    value: function renderModalLink() {
      var _this12 = this;
      return /*#__PURE__*/React.createElement("i", {
        role: "button",
        tabIndex: 0,
        className: "fa fa-edit modal-link",
        onClick: function onClick() {
          return _this12.setState({
            showModal: true
          });
        }
      }, this.props.formType === 'modal-link' ? 'Edit' : '');
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.formType === 'page') {
        return this.renderContent();
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderModalLink(), this.renderModal());
    }
  }]);
}(React.Component);
ProjectBudgetLogistics.propTypes = {
  formType: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string,
  back: PropTypes.func,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  showBackgroundCheck: PropTypes.bool
};
ProjectBudgetLogistics.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  back: function back() {},
  afterSubmit: function afterSubmit() {},
  backButtonText: 'Back',
  submitButtonText: 'Next',
  showBackgroundCheck: false
};
export default ProjectBudgetLogistics;